import store from "@frameworks/web/redux/store";
import { GUEST_EMAIL_OTP, GUEST_EMAIL_OTP_ERROR, GUEST_EMAIL_OTP_HIDE_ERROR, GUEST_EMAIL_OTP_START_LOADER, GUEST_EMAIL_OTP_STOP_LOADER, } from "../interface/IGuestEmailVerifyOTP";
class GuestEmailVerifyOTPActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    GuestVerifyEmailOTP(data) {
        this.dispatch({
            type: GUEST_EMAIL_OTP,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GUEST_EMAIL_OTP_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GUEST_EMAIL_OTP_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: GUEST_EMAIL_OTP_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: GUEST_EMAIL_OTP_STOP_LOADER,
        });
    }
}
export default GuestEmailVerifyOTPActions;
